import { Injectable } from '@angular/core';
import { FormGroup, FormControl, AbstractControl, ValidationErrors } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class ValidationErrorService {
  errorList: string[] = new Array<string>();
  form: FormGroup;

  constructor() {}

  public loadForm(form: FormGroup) {
    if (form) {
      this.form = form;
      this.generateErrors();
    }
  }

  public generateErrors(): void {
    this.errorList = new Array<string>();

    Object.keys(this.form.controls).forEach(key => {
      let validator: ValidationErrors;

      if (this.form.controls[key].validator) {
        validator = this.form.controls[key].validator({} as AbstractControl);
      }
      
      if (this.form.controls[key].invalid && this.form.controls[key].touched) {
        Object.keys(this.form.controls[key].errors).forEach(error => {
          this.errorList.push(key.toUpperCase() + '_' + error.toUpperCase());
        });
      } 
      else if (!this.form.controls[key].touched && validator && validator['required']) {
        this.errorList.push(key.toUpperCase() + '_' + 'REQUIRED');
      }
    });
  }

  public get showBanner() {
    return this.errorList.length > 0;
  }
}
